/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Component, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';

/**
 * Report Steps Bar component.
 *
 */
@Component({
    name: 'c-report-stage-bar',
})
export default class ReportStageBar extends Vue {
    @Getter('stage', {namespace: 'formStateModule'})
    public stage!: number;

    @Action('updateStage', {namespace: 'formStateModule'})
    public updateStage: any;

}
